import { atempl } from '@api/v0/fetch/.endpoints';
import FilterHelpers from '@resources/filter-helpers/FilterHelpers';

export class PostRequest {
	constructor() {
		this.init();
	}

	init(){
		this.id = 'post';
		this.formId = '#archive-post-filter'
		this.setPayload();
		this.setDataProcessor();
		this.setUrlHandler();
		this.createFilter();
		this.eventListeners();
	}

	setPayload() {
		atempl.models.setPayload(this.id, {
			'model': 'Post',
			'cache': false,
			'fields': ['id', 'title', 'permalink', 'byline', 'strapline', 'excerpt', 'thumbnail', 'link'],
			'args': {
				'lang': atnlbs_default.lang,
				'posts_per_page': 12,
			}
		}, {
			'X-WP-Nonce': atnlbs_default.nonce
		});
	}

	setDataProcessor(){
		atempl.templateProcessor.setFunc('makelinkattr', (arr) => {
			return arr && Object.keys(arr).length ? `href="${arr.url}" target="${arr.target}"` : ''
		});
		atempl.templateProcessor.setFunc('linkTitle', (arr) => {
			return arr?.title ? arr.title : ''
		});
	}

	setUrlHandler() {

		const getTax = (urlParams, tax) => urlParams['category'] || (window.atnlbs_default.query_vars?.taxonomy === tax && window.atnlbs_default.query_vars.term)

		this.urlHandler = {
			'setter': (payloadArgs) => {
				const taxFilters = {
					category: payloadArgs.tax_filters?.category,
				};

				const nonTaxFilters = {
					f_year: payloadArgs.year,
				};

				return FilterHelpers.buildFilterUrl(window.location.href, taxFilters, nonTaxFilters);
			},
			'getter': (urlParams) => {
				let get = {
					tax_filters: {
						category: FilterHelpers.getTaxTerm(urlParams, 'category'),
					},
					year: urlParams.f_year
				};

				Object.keys(get.tax_filters).forEach(k => !get.tax_filters[k] && delete get.tax_filters[k]);
				if (Object.keys(get.tax_filters).length === 0) delete get.tax_filters;
				if (!get.year) delete get.year;
				return get;
			},
			'interface': (filterForm, urlParams, payload) => {
				FilterHelpers.applyFiltersToAtnlSelects(
					filterForm,
					urlParams,
					['category'],
					['f_year']
				);
			}
		};
	}

	createFilter() {
		const formId = this.formId;
		atempl.createFilter(this.id, formId, this.urlHandler);

		atempl.setFilterStep(this.id, 'change', (args, data, e) => {
			args.paged = 1;
			args.tax_filters = { relation: 'AND' }

			args.tax_filters.category = data.category && data.category.length ? data.category : null;
			args.year = data.year && data.year.length ? data.year : null

			!args.tax_filters.category && (args.tax_filters = null);

			return args;
		});
	}

	eventListeners() {
		// query based on the post type instructions of the holder.
		window.addEventListener('atempl:beforeFetch', (e) => {
			const hasFilter = !atempl.hasFilter(e.detail.payload.initArgs, e.detail.payload.body.args)
			const firstPage = !e.detail.payload.body.args?.paged || e.detail.payload.body.args.paged === 1
			const hasSticky = e.detail.wrapper.dataset.sticky === "true";
			const perPage = e.detail.wrapper.dataset.n ? ( hasSticky && firstPage && !hasFilter ? parseInt(e.detail.wrapper.dataset.n) + 2 : e.detail.wrapper.dataset.n ) : 12;
			e.detail.payload.body.args.posts_per_page = perPage;
			return e.detail;
		})
	}

}

new PostRequest();
